// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-48a2ac1d] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.widget-custom[data-v-48a2ac1d] {
  width: 100%;
  margin: auto;
  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);
  margin-top: calc(var(--default-grid-baseline, 4px) * 3);
  overflow: hidden;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-large);
  background-color: transparent;
  display: flex;
}
.widget-custom.full-width[data-v-48a2ac1d] {
  width: var(--widget-full-width, 100%) !important;
  left: calc((var(--widget-full-width, 100%) - 100%) / 2 * -1);
  position: relative;
}
.widget-access[data-v-48a2ac1d] {
  width: 100%;
  margin: auto;
  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);
  margin-top: calc(var(--default-grid-baseline, 4px) * 3);
  overflow: hidden;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-large);
  background-color: transparent;
  display: flex;
  padding: calc(var(--default-grid-baseline, 4px) * 3);
}
.widget-default[data-v-48a2ac1d] {
  width: 100%;
  margin: auto;
  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);
  margin-top: calc(var(--default-grid-baseline, 4px) * 3);
  overflow: hidden;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-large);
  background-color: transparent;
  display: flex;
}
.widget-default--compact[data-v-48a2ac1d] {
  flex-direction: column;
}
.widget-default--compact .widget-default--image[data-v-48a2ac1d] {
  width: 100%;
  height: 150px;
}
.widget-default--compact .widget-default--details[data-v-48a2ac1d] {
  width: 100%;
  padding-top: calc(var(--default-grid-baseline, 4px) * 2);
  padding-bottom: calc(var(--default-grid-baseline, 4px) * 2);
}
.widget-default--compact .widget-default--description[data-v-48a2ac1d] {
  display: none;
}
.widget-default--image[data-v-48a2ac1d] {
  width: 40%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.widget-default--name[data-v-48a2ac1d] {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
}
.widget-default--details[data-v-48a2ac1d] {
  padding: calc(var(--default-grid-baseline, 4px) * 3);
  width: 60%;
}
.widget-default--details p[data-v-48a2ac1d] {
  margin: 0;
  padding: 0;
}
.widget-default--description[data-v-48a2ac1d] {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
.widget-default--link[data-v-48a2ac1d] {
  color: var(--color-text-maxcontrast);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.toggle-interactive[data-v-48a2ac1d] {
  position: relative;
}
.toggle-interactive .toggle-interactive--button[data-v-48a2ac1d] {
  position: absolute;
  top: 50%;
  z-index: 10000;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  opacity: 0;
}
.toggle-interactive:focus-within .toggle-interactive--button[data-v-48a2ac1d], .toggle-interactive:hover .toggle-interactive--button[data-v-48a2ac1d] {
  opacity: 1;
}
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-25f1cef8] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-e880790e] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.provider-list[data-v-e880790e] {
  width: 100%;
  min-height: 400px;
  padding: 0 16px 16px 16px;
  display: flex;
  flex-direction: column;
}
.provider-list--select[data-v-e880790e] {
  width: 100%;
}
.provider-list--select .provider[data-v-e880790e] {
  display: flex;
  align-items: center;
  height: 28px;
  overflow: hidden;
}
.provider-list--select .provider .link-icon[data-v-e880790e] {
  margin-right: 8px;
}
.provider-list--select .provider .provider-icon[data-v-e880790e] {
  width: 20px;
  height: 20px;
  object-fit: contain;
  margin-right: 8px;
  filter: var(--background-invert-if-dark);
}
.provider-list--select .provider .option-text[data-v-e880790e] {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-d0ba247a] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.raw-link[data-v-d0ba247a] {
  width: 100%;
  min-height: 350px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 0 16px 16px 16px;
}
.raw-link .input-wrapper[data-v-d0ba247a] {
  width: 100%;
}
.raw-link .reference-widget[data-v-d0ba247a] {
  display: flex;
}
.raw-link--empty-content .provider-icon[data-v-d0ba247a] {
  width: 150px;
  height: 150px;
  object-fit: contain;
  filter: var(--background-invert-if-dark);
}
.raw-link--input[data-v-d0ba247a] {
  width: 99%;
}
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-7a394a58] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.result[data-v-7a394a58] {
  display: flex;
  align-items: center;
  height: 44px;
  overflow: hidden;
}
.result--icon-class[data-v-7a394a58], .result--image[data-v-7a394a58] {
  width: 40px;
  min-width: 40px;
  height: 40px;
  object-fit: contain;
}
.result--icon-class.rounded[data-v-7a394a58], .result--image.rounded[data-v-7a394a58] {
  border-radius: 50%;
}
.result--content[data-v-7a394a58] {
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  overflow: hidden;
}
.result--content--name[data-v-7a394a58], .result--content--subline[data-v-7a394a58] {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-97d196f0] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.smart-picker-search[data-v-97d196f0] {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 16px 16px 16px;
}
.smart-picker-search.with-empty-content[data-v-97d196f0] {
  min-height: 400px;
}
.smart-picker-search .provider-icon[data-v-97d196f0] {
  width: 150px;
  height: 150px;
  object-fit: contain;
  filter: var(--background-invert-if-dark);
}
.smart-picker-search--select[data-v-97d196f0] {
  width: 100%;
}
.smart-picker-search--select .search-result[data-v-97d196f0] {
  width: 100%;
}
.smart-picker-search--select .group-name-icon[data-v-97d196f0],
.smart-picker-search--select .option-simple-icon[data-v-97d196f0] {
  width: 20px;
  height: 20px;
  margin: 0 20px 0 10px;
}
.smart-picker-search--select .custom-option[data-v-97d196f0] {
  height: 44px;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.smart-picker-search--select .option-text[data-v-97d196f0] {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-12c38c93] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.reference-picker[data-v-12c38c93] {
  display: flex;
  overflow-y: auto;
  width: 100%;
}
.reference-picker .custom-element-wrapper[data-v-12c38c93] {
  display: flex;
  overflow-y: auto;
  width: 100%;
}
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.reference-picker-modal .modal-container {
  display: flex !important;
}
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-ab09ebaa] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.reference-picker-modal--content[data-v-ab09ebaa] {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
}
.reference-picker-modal--content .close-button[data-v-ab09ebaa],
.reference-picker-modal--content .back-button[data-v-ab09ebaa] {
  position: absolute;
  top: 4px;
}
.reference-picker-modal--content .back-button[data-v-ab09ebaa] {
  left: 4px;
}
.reference-picker-modal--content .close-button[data-v-ab09ebaa] {
  right: 4px;
}
.reference-picker-modal--content > h2[data-v-ab09ebaa] {
  display: flex;
  margin: 12px 0 20px 0;
}
.reference-picker-modal--content > h2 .icon[data-v-ab09ebaa] {
  margin-right: 8px;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/referencePickerModal-BaGbKZky.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,0DAA0D;EAC1D,uDAAuD;EACvD,gBAAgB;EAChB,qCAAqC;EACrC,yCAAyC;EACzC,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,gDAAgD;EAChD,4DAA4D;EAC5D,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,0DAA0D;EAC1D,uDAAuD;EACvD,gBAAgB;EAChB,qCAAqC;EACrC,yCAAyC;EACzC,6BAA6B;EAC7B,aAAa;EACb,oDAAoD;AACtD;AACA;EACE,WAAW;EACX,YAAY;EACZ,0DAA0D;EAC1D,uDAAuD;EACvD,gBAAgB;EAChB,qCAAqC;EACrC,yCAAyC;EACzC,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,wDAAwD;EACxD,2DAA2D;AAC7D;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,oDAAoD;EACpD,UAAU;AACZ;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,SAAS;EACT,4CAA4C;EAC5C,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,UAAU;AACZ;AACA;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;AACA;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-48a2ac1d] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.widget-custom[data-v-48a2ac1d] {\n  width: 100%;\n  margin: auto;\n  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);\n  margin-top: calc(var(--default-grid-baseline, 4px) * 3);\n  overflow: hidden;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-large);\n  background-color: transparent;\n  display: flex;\n}\n.widget-custom.full-width[data-v-48a2ac1d] {\n  width: var(--widget-full-width, 100%) !important;\n  left: calc((var(--widget-full-width, 100%) - 100%) / 2 * -1);\n  position: relative;\n}\n.widget-access[data-v-48a2ac1d] {\n  width: 100%;\n  margin: auto;\n  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);\n  margin-top: calc(var(--default-grid-baseline, 4px) * 3);\n  overflow: hidden;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-large);\n  background-color: transparent;\n  display: flex;\n  padding: calc(var(--default-grid-baseline, 4px) * 3);\n}\n.widget-default[data-v-48a2ac1d] {\n  width: 100%;\n  margin: auto;\n  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);\n  margin-top: calc(var(--default-grid-baseline, 4px) * 3);\n  overflow: hidden;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-large);\n  background-color: transparent;\n  display: flex;\n}\n.widget-default--compact[data-v-48a2ac1d] {\n  flex-direction: column;\n}\n.widget-default--compact .widget-default--image[data-v-48a2ac1d] {\n  width: 100%;\n  height: 150px;\n}\n.widget-default--compact .widget-default--details[data-v-48a2ac1d] {\n  width: 100%;\n  padding-top: calc(var(--default-grid-baseline, 4px) * 2);\n  padding-bottom: calc(var(--default-grid-baseline, 4px) * 2);\n}\n.widget-default--compact .widget-default--description[data-v-48a2ac1d] {\n  display: none;\n}\n.widget-default--image[data-v-48a2ac1d] {\n  width: 40%;\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.widget-default--name[data-v-48a2ac1d] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: bold;\n}\n.widget-default--details[data-v-48a2ac1d] {\n  padding: calc(var(--default-grid-baseline, 4px) * 3);\n  width: 60%;\n}\n.widget-default--details p[data-v-48a2ac1d] {\n  margin: 0;\n  padding: 0;\n}\n.widget-default--description[data-v-48a2ac1d] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  -webkit-box-orient: vertical;\n}\n.widget-default--link[data-v-48a2ac1d] {\n  color: var(--color-text-maxcontrast);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.toggle-interactive[data-v-48a2ac1d] {\n  position: relative;\n}\n.toggle-interactive .toggle-interactive--button[data-v-48a2ac1d] {\n  position: absolute;\n  top: 50%;\n  z-index: 10000;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  opacity: 0;\n}\n.toggle-interactive:focus-within .toggle-interactive--button[data-v-48a2ac1d], .toggle-interactive:hover .toggle-interactive--button[data-v-48a2ac1d] {\n  opacity: 1;\n}\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-25f1cef8] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-e880790e] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.provider-list[data-v-e880790e] {\n  width: 100%;\n  min-height: 400px;\n  padding: 0 16px 16px 16px;\n  display: flex;\n  flex-direction: column;\n}\n.provider-list--select[data-v-e880790e] {\n  width: 100%;\n}\n.provider-list--select .provider[data-v-e880790e] {\n  display: flex;\n  align-items: center;\n  height: 28px;\n  overflow: hidden;\n}\n.provider-list--select .provider .link-icon[data-v-e880790e] {\n  margin-right: 8px;\n}\n.provider-list--select .provider .provider-icon[data-v-e880790e] {\n  width: 20px;\n  height: 20px;\n  object-fit: contain;\n  margin-right: 8px;\n  filter: var(--background-invert-if-dark);\n}\n.provider-list--select .provider .option-text[data-v-e880790e] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-d0ba247a] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.raw-link[data-v-d0ba247a] {\n  width: 100%;\n  min-height: 350px;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  padding: 0 16px 16px 16px;\n}\n.raw-link .input-wrapper[data-v-d0ba247a] {\n  width: 100%;\n}\n.raw-link .reference-widget[data-v-d0ba247a] {\n  display: flex;\n}\n.raw-link--empty-content .provider-icon[data-v-d0ba247a] {\n  width: 150px;\n  height: 150px;\n  object-fit: contain;\n  filter: var(--background-invert-if-dark);\n}\n.raw-link--input[data-v-d0ba247a] {\n  width: 99%;\n}\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-7a394a58] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.result[data-v-7a394a58] {\n  display: flex;\n  align-items: center;\n  height: 44px;\n  overflow: hidden;\n}\n.result--icon-class[data-v-7a394a58], .result--image[data-v-7a394a58] {\n  width: 40px;\n  min-width: 40px;\n  height: 40px;\n  object-fit: contain;\n}\n.result--icon-class.rounded[data-v-7a394a58], .result--image.rounded[data-v-7a394a58] {\n  border-radius: 50%;\n}\n.result--content[data-v-7a394a58] {\n  display: flex;\n  flex-direction: column;\n  padding-left: 10px;\n  overflow: hidden;\n}\n.result--content--name[data-v-7a394a58], .result--content--subline[data-v-7a394a58] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-97d196f0] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.smart-picker-search[data-v-97d196f0] {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 0 16px 16px 16px;\n}\n.smart-picker-search.with-empty-content[data-v-97d196f0] {\n  min-height: 400px;\n}\n.smart-picker-search .provider-icon[data-v-97d196f0] {\n  width: 150px;\n  height: 150px;\n  object-fit: contain;\n  filter: var(--background-invert-if-dark);\n}\n.smart-picker-search--select[data-v-97d196f0] {\n  width: 100%;\n}\n.smart-picker-search--select .search-result[data-v-97d196f0] {\n  width: 100%;\n}\n.smart-picker-search--select .group-name-icon[data-v-97d196f0],\n.smart-picker-search--select .option-simple-icon[data-v-97d196f0] {\n  width: 20px;\n  height: 20px;\n  margin: 0 20px 0 10px;\n}\n.smart-picker-search--select .custom-option[data-v-97d196f0] {\n  height: 44px;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n}\n.smart-picker-search--select .option-text[data-v-97d196f0] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-12c38c93] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.reference-picker[data-v-12c38c93] {\n  display: flex;\n  overflow-y: auto;\n  width: 100%;\n}\n.reference-picker .custom-element-wrapper[data-v-12c38c93] {\n  display: flex;\n  overflow-y: auto;\n  width: 100%;\n}\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.reference-picker-modal .modal-container {\n  display: flex !important;\n}\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-ab09ebaa] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.reference-picker-modal--content[data-v-ab09ebaa] {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow-y: auto;\n}\n.reference-picker-modal--content .close-button[data-v-ab09ebaa],\n.reference-picker-modal--content .back-button[data-v-ab09ebaa] {\n  position: absolute;\n  top: 4px;\n}\n.reference-picker-modal--content .back-button[data-v-ab09ebaa] {\n  left: 4px;\n}\n.reference-picker-modal--content .close-button[data-v-ab09ebaa] {\n  right: 4px;\n}\n.reference-picker-modal--content > h2[data-v-ab09ebaa] {\n  display: flex;\n  margin: 12px 0 20px 0;\n}\n.reference-picker-modal--content > h2 .icon[data-v-ab09ebaa] {\n  margin-right: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
